import React from "react";
import StepForm from "../stepForm";

const Formulario = () => {
  return <StepForm />;
};

export default Formulario;
